import { Link } from "react-router-dom";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, H6, Image, P } from "../../../AbstractElements";
import { AuthSignIn, CreateAccount, CreateYourAccount, AlreadyHaveAnAccount, OrSignUpWith, PrivacyPolicy, EnterYourPersonalDetailsToCreateAccount, YourNameSignUp, EmailAddressSignUp, PasswordSignUp, AgreeWithSignUp } from "../../../Constant";
import { useState } from "react";
import { OtherWay } from "./OtherWay";
import { Formik, Form, Field } from "formik";
import { SignupProp, SignupSubmitProp } from "../../../Type/Pages";
import { dynamicImage } from "../../../Service/DynamicImage";

export const RegisterForm = ({ logoClass }: SignupProp) => {
  const [show, setShow] = useState(false);
  const submitHandler = (values: SignupSubmitProp, { resetForm }: { resetForm: () => void }) => {
    resetForm();
  };

  return (
    <div>
      <div>
        <Link className={`logo ${logoClass}`} to={`${process.env.PUBLIC_URL}/dashboard/default`}>
          <Image className="img-fluid for-light" src={dynamicImage("logo/logo_dark.png")} alt="looginpage" />
          <Image className="img-fluid for-dark" src={dynamicImage("logo/logo.png")} alt="looginpage" />
        </Link>
      </div>
      <div className="login-main">
        <Formik initialValues={{ firstname: "", lastname: "", email: "", password: "" }} onSubmit={submitHandler}>
          {() => (
            <Form className="theme-form">
              <H4>{CreateYourAccount}</H4>
              <P>{EnterYourPersonalDetailsToCreateAccount}</P>
              <FormGroup>
                <Label className="pt-0 col-form-label">{YourNameSignUp}</Label>
                <Row className="g-2">
                  <Col sm="6">
                    <Field className="form-control" type="text" name="firstname" required placeholder="First name" />
                  </Col>
                  <Col sm="6">
                    <Field className="form-control" type="text" name="lastname" required placeholder="Last name" />
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">{EmailAddressSignUp}</Label>
                <Field name="email" type="email" className="form-control" required placeholder="Test@gmail.com" />
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">{PasswordSignUp}</Label>
                <div className="form-input position-relative">
                  <Field className="form-control" name="password" type={show ? "text" : "password"} required placeholder="*********" />
                  <div className="show-hide" onClick={() => setShow(!show)}>
                    <span className="show"></span>
                  </div>
                </div>
              </FormGroup>
              <FormGroup className="mb-0">
                <div className="checkbox p-0">
                  <Input id="checkbox1" type="checkbox" />
                  <Label className="text-muted" htmlFor="checkbox1">
                    {AgreeWithSignUp}
                    <Link className="ms-2" to="#javascript">
                      {PrivacyPolicy}
                    </Link>
                  </Label>
                </div>
                <Btn color="primary" className="btn-block w-100" type="submit">
                  {CreateAccount}
                </Btn>
              </FormGroup>
              <H6 className="text-muted mt-4 or">{OrSignUpWith}</H6>
              <OtherWay />
              <P className="mt-4 mb-0 text-center">
                {AlreadyHaveAnAccount}
                <Link className="ms-2" to={`${process.env.PUBLIC_URL}/auth/login`}>
                  {AuthSignIn}
                </Link>
              </P>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
